// Helpers for launching the user's own email / SMS app via mailto: and sms:
// URLs. We can't confirm send; these just hand off to the OS. Callers are
// responsible for logging the attempt before navigating.

import { supabase } from './supabase'

function encodeBody(body) {
  // URLSearchParams encodes spaces as '+', which mailto clients don't decode.
  // Use encodeURIComponent directly and swap '+' for '%20' manually.
  return encodeURIComponent(body || '').replace(/%20/g, '%20')
}

export function buildMailto(opts) {
  var to = opts && opts.to ? encodeURIComponent(opts.to) : ''
  var parts = []
  if (opts && opts.subject) parts.push('subject=' + encodeBody(opts.subject))
  if (opts && opts.body) parts.push('body=' + encodeBody(opts.body))
  if (opts && opts.cc) parts.push('cc=' + encodeURIComponent(opts.cc))
  if (opts && opts.bcc) parts.push('bcc=' + encodeURIComponent(opts.bcc))
  return 'mailto:' + to + (parts.length ? '?' + parts.join('&') : '')
}

export function buildSmsUrl(phone, message) {
  // Strip everything but digits and a leading '+'.
  var digits = (phone || '').replace(/[^\d+]/g, '')
  var body = message ? '?&body=' + encodeBody(message) : ''
  // iOS uses `sms:NUMBER&body=...`, Android accepts both `?` and `&`.
  // `sms:NUMBER?&body=` threads both. The `?&` is intentional.
  return 'sms:' + digits + body
}

// Log a follow-up attempt to store_email_logs. Returns the inserted row or
// null on failure. Caller should await this before navigating so the write
// lands before the page unloads to the email/SMS app.
export async function logFollowUpAttempt(row) {
  var payload = {
    store_user_id: row.storeUserId,
    customer_id: row.customerId || null,
    request_id: row.requestId || null,
    client_name: row.clientName || null,
    client_email: row.clientEmail || null,
    subject: row.subject || null,
    body: row.body || null,
    sent_at: new Date().toISOString(),
    send_method: row.sendMethod || 'mailto',
  }
  var res = await supabase.from('store_email_logs').insert(payload).select().single()
  if (res.error) {
    // eslint-disable-next-line no-console
    console.error('[followUpLinks] log insert failed', res.error)
    return null
  }
  return res.data
}

// Bump last_contact_date on a customer + contact_count on a request.
export async function markContacted(opts) {
  var today = new Date().toISOString()
  var updates = []
  if (opts && opts.customerId) {
    updates.push(
      supabase.from('store_customers')
        .update({ last_contact_date: today.split('T')[0] })
        .eq('id', opts.customerId)
    )
  }
  if (opts && opts.request) {
    updates.push(
      supabase.from('store_requests')
        .update({
          last_contact_at: today,
          contact_count: (opts.request.contact_count || 0) + 1,
        })
        .eq('id', opts.request.id)
    )
  }
  if (updates.length === 0) return
  var results = await Promise.all(updates)
  results.forEach(function(r) {
    if (r && r.error) console.warn('[followUpLinks] markContacted update failed', r.error)
  })
}
